import { HOUSE_BRAND, brandByKey, type BrandDefinition } from "@school-sales-ai/shared";
import { useClientBranding } from "@/hooks/useClientBranding";

/**
 * The active client's brand when it must be told about the house brand, else null.
 *
 * Stripe and Meta are ONE account each, both shown as the company (CLAUDE.md §8,
 * "House brand"), so a client of any other brand meets a name it never signed up
 * with — on its card statement and in Meta's connect pop-up. An unrecognized name
 * on a charge is how a legitimate charge becomes a dispute, so those surfaces say it
 * first. A client of the house brand already expects it and is told nothing.
 *
 * Null while the branding is loading: `brandByKey(undefined)` falls back to the
 * default brand, which would flash the notice at a house-brand client.
 */
export function useHouseBrandNotice(): BrandDefinition | null {
  const { data } = useClientBranding();
  if (!data) return null;
  const brand = brandByKey(data.brand);
  return brand.key === HOUSE_BRAND.key ? null : brand;
}
